/**
 * 客户
 */

import Layout from '@/layout/Layout.vue'

export default {
  path: '/customer',
  name: '客户',
  component: Layout,
  redirect: '/customer',
  children: [
    {
      path: '/customer/management',
      name: '客户管理',
      component: () => import('@/views/customer/customer-management/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'customer_management'
      }
    }, {
      path: '/customer/management/detail',
      name: '客户详情',
      component: () => import('@/views/customer/customer-management/Detail.vue'),
      meta: {
        father: {
          name: '客户管理',
          path: '/customer/management'
        }
      }
    }, {
      path: '/customer/management/certification',
      name: '认证审核',
      component: () => import('@/views/customer/customer-management/Certification.vue'),
      meta: {
        father: {
          name: '客户管理',
          path: '/customer/management'
        }
      }
    }
  ],
}